const icon = require('./icons/bed-exit-100.png')

export const BedExitIcon = () => {
    return <img src={icon} alt="out of bed icon" className="w-full h-full"/>
}
